var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.05,
    height: 258.805,
    viewBox: "0 0 212.05 258.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#524cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5953b6",
    stopOpacity: 0.471
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{opacity:.3;fill:url(#linear-gradient)}.cls-2{fill:#5d56c4}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7230",
    transform: "translate(-1751.552 -222.515)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_381",
    cx: 44.597,
    cy: 44.597,
    r: 44.597,
    className: "cls-1",
    transform: "translate(1769.128 336.024)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382",
    cx: 28.742,
    cy: 28.742,
    r: 28.742,
    className: "cls-1",
    transform: "translate(1901.923 334.195)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7227",
    transform: "translate(1751.552 222.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    d: "M1946.833 225.515h-36.418a2.237 2.237 0 1 0 0 4.475h36.416a12.636 12.636 0 0 1 12.62 12.621v61.067a12.634 12.634 0 0 1-12.62 12.621h-37.66a2.236 2.236 0 0 0-2.237 2.237v20.028l-24.568-21.7a2.231 2.231 0 0 0-1.481-.559h-36.848a12.636 12.636 0 0 1-12.621-12.621V242.61a12.635 12.635 0 0 1 12.621-12.621h19.863a2.237 2.237 0 1 0 0-4.475h-19.862a17.115 17.115 0 0 0-17.095 17.1v47.678a97.406 97.406 0 1 0 98.539 30.483h21.353a17.115 17.115 0 0 0 17.095-17.1V242.61a17.117 17.117 0 0 0-17.095-17.1zm-149.706 233.736v-24.494a30.193 30.193 0 0 1 28.333-30.085 42.489 42.489 0 0 0 52.829 0 30.192 30.192 0 0 1 28.333 30.085v24.494a92.578 92.578 0 0 1-109.5 0zm54.746-49.845a38.254 38.254 0 1 1 38.254-38.253 38.3 38.3 0 0 1-38.254 38.254zm92.845-25.08a92.691 92.691 0 0 1-33.624 71.448v-21.017a34.7 34.7 0 0 0-28.418-34.07 42.729 42.729 0 1 0-61.608 0 34.692 34.692 0 0 0-28.418 34.07v21.019a92.782 92.782 0 0 1 34.289-160.866v8.768a17.115 17.115 0 0 0 17.095 17.1h36l27.653 24.429a2.237 2.237 0 0 0 3.718-1.678v-22.755h8.057a92.477 92.477 0 0 1 25.257 63.552z",
    className: "cls-2",
    transform: "translate(-1753.215 -224.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    d: "M1850.21 481.32a98.637 98.637 0 0 1-26.269-193.72v-46.653a18.453 18.453 0 0 1 18.432-18.432h19.863a3.574 3.574 0 1 1 0 7.148h-19.863a11.3 11.3 0 0 0-11.283 11.284v61.069a11.3 11.3 0 0 0 11.283 11.284h36.848a3.567 3.567 0 0 1 2.368.9l22.344 19.74v-17.068a3.578 3.578 0 0 1 3.575-3.574h37.66a11.3 11.3 0 0 0 11.284-11.284v-61.067a11.3 11.3 0 0 0-11.284-11.284h-36.417a3.574 3.574 0 1 1 0-7.148h36.418a18.456 18.456 0 0 1 18.432 18.432v61.067a18.453 18.453 0 0 1-18.432 18.432h-18.485a98.573 98.573 0 0 1-76.474 160.874zm-7.837-256.132a15.777 15.777 0 0 0-15.758 15.759v48.707l-.994.264a96.068 96.068 0 1 0 97.185 30.065l-1.912-2.211h24.275a15.776 15.776 0 0 0 15.759-15.758v-61.067a15.78 15.78 0 0 0-15.759-15.759h-36.418a.9.9 0 1 0 0 1.8h36.417a13.974 13.974 0 0 1 13.957 13.957v61.067a13.974 13.974 0 0 1-13.957 13.957h-37.66a.9.9 0 0 0-.9.9v22.992l-26.791-23.661a.9.9 0 0 0-.6-.224h-36.848a13.973 13.973 0 0 1-13.957-13.957v-61.072a13.973 13.973 0 0 1 13.957-13.957h19.863a.9.9 0 0 0 0-1.8zm7.837 251.659a93.361 93.361 0 0 1-55.537-18.181l-.546-.4v-25.172a31.535 31.535 0 0 1 29.588-31.419l.51-.031.4.316a41.152 41.152 0 0 0 51.172 0l.4-.316.51.031a31.536 31.536 0 0 1 29.589 31.419v25.171l-.546.4a93.364 93.364 0 0 1-55.54 18.182zm-53.409-19.94a91.24 91.24 0 0 0 106.822 0v-23.813a28.858 28.858 0 0 0-26.578-28.716 43.821 43.821 0 0 1-53.666 0 28.858 28.858 0 0 0-26.577 28.716zm-4.477.054l-2.191-1.819a94.012 94.012 0 0 1-14.544-129.867 95.025 95.025 0 0 1 49.327-33.315l1.7-.473v10.529a15.776 15.776 0 0 0 15.758 15.758h36.507l28.031 24.764a.917.917 0 0 0 .971.144.9.9 0 0 0 .526-.82v-24.088h9.971l.4.421a94 94 0 0 1-8.487 136.945l-2.191 1.819v-23.865a33.29 33.29 0 0 0-27.321-32.755l-2.445-.447 1.72-1.794a41.393 41.393 0 1 0-59.679 0l1.721 1.794-2.446.447a33.287 33.287 0 0 0-27.321 32.755zm31.615-161.934a91.439 91.439 0 0 0-34.289 156.182v-18.115a35.958 35.958 0 0 1 27.205-34.885 44.065 44.065 0 1 1 66.708 0 35.962 35.962 0 0 1 27.2 34.885v18.111a91.312 91.312 0 0 0 6.451-130.758h-6.139v21.415a3.574 3.574 0 0 1-5.94 2.68l-27.274-24.094h-35.494a18.453 18.453 0 0 1-18.432-18.432zm26.271 114.053a39.591 39.591 0 1 1 39.59-39.59 39.636 39.636 0 0 1-39.59 39.59zm0-76.508a36.917 36.917 0 1 0 36.917 36.919 36.96 36.96 0 0 0-36.917-36.919z",
    className: "cls-2",
    transform: "translate(-1751.552 -222.515)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7226",
    transform: "translate(117.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    d: "M2019.546 229.99h26.848a2.237 2.237 0 0 0 0-4.475h-26.848a2.237 2.237 0 0 0 0 4.475z",
    className: "cls-2",
    transform: "translate(-2015.972 -224.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    d: "M2044.73 229.663h-26.848a3.574 3.574 0 0 1 0-7.148h26.848a3.574 3.574 0 0 1 0 7.148zm-26.848-4.475a.9.9 0 0 0 0 1.8h26.848a.9.9 0 0 0 0-1.8z",
    className: "cls-2",
    transform: "translate(-2014.309 -222.515)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7229",
    transform: "translate(1866.004 247.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    d: "M2031.817 290.239a5.582 5.582 0 0 0 4.653 2.528 5.452 5.452 0 0 0 4.382-2.575 8.932 8.932 0 0 1 16 .938 3.343 3.343 0 0 0 6.148-2.63 15.6 15.6 0 0 0-26.666-3.5c-9.148-11.72-27.947-5.062-27.933 9.665.016 15.484 13.422 27.325 25.965 33.245a4.665 4.665 0 0 0 3.986 0c9.018-4.278 18.6-11.87 23.041-21.038a3.342 3.342 0 1 0-6.017-2.912c-3.615 7.47-11.622 13.756-19.027 17.488-10.432-5.159-21.25-14.758-21.262-26.786-.007-9.071 12.165-12.456 16.73-4.423z",
    className: "cls-2",
    transform: "translate(-2008.403 -278.984)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain3);
export default __webpack_public_path__ + "static/media/retain3.4a32538f17e4fb7df84fa7b2dc173fa9.svg";
export { ForwardRef as ReactComponent };